import { connect } from 'react-redux';
import { withI18n } from 'react-i18next';
import { withRouter } from 'react-router';

import Lists from './Lists';

import { IInitialState } from 'src/store/initialState';
import {
  listsActions,
  listsIsPendingSel,
  listsSel,
  listsErrorSel,
  currentListSel,
  listsIsUpdatingSel,
  listsSuccessSel
} from 'src/store/modules/lists';
import {
  warrantyProvidersSel,
  warrantyActions
} from 'src/store/modules/warranty';
import {
  cartActions,
  cartErrorSel,
  cartSuccessSel,
  cartIsPendingSel
} from 'src/store/modules/cart';
import { userActions, userDataSel } from 'src/store/modules/user';
import { ICartServiceItem } from 'src/services/cart/CartService';

const mapStateToProps = (state: IInitialState) => ({
  lists: listsSel(state),
  currentList: currentListSel(state),
  isPending: listsIsPendingSel(state),
  isUpdating: listsIsUpdatingSel(state),
  userData: userDataSel(state),
  error: listsErrorSel(state),
  success: listsSuccessSel(state),
  cartError: cartErrorSel(state),
  cartSuccess: cartSuccessSel(state),
  warranties: warrantyProvidersSel(state),
  cartIsPending: cartIsPendingSel(state)
});

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  onLoad: () => {
    dispatch(userActions.getUserDetails());
    dispatch(warrantyActions.getWarranty());
    dispatch(listsActions.getLists());
  },
  onClearList: () => dispatch(listsActions.clearCurrentList()),
  onClearfavList: () => dispatch(listsActions.clearCurrentList()),
  onGetList: (id: number) => dispatch(listsActions.getList(id)),
  onClearLists: (id: number) => dispatch(listsActions.ClearLists(id)),
  onCreateList: (name: string) => dispatch(listsActions.createList(name)),
  onUpdateList: (id: number, name: string) =>
    dispatch(listsActions.updateList(id, name)),
  onDeleteList: (id: number) => dispatch(listsActions.deleteList(id)),
  onItemUpdate: (
    itemId: number,
    name: string,
    mfc: string,
    quantity: number,
    shipmentMarking: string,
    warrantyProvider: string,
    claims: string
  ) =>
    dispatch(
      listsActions.updateItem(
        itemId,
        name,
        mfc,
        quantity,
        shipmentMarking,
        warrantyProvider,
        claims
      )
    ),
  onRemoveItem: (itemId: number) => dispatch(listsActions.deleteItem(itemId)),
  onItemDetailsUpdate: (itemId: number) =>
    dispatch(listsActions.updateItemDetails(itemId)),
  onItemsDetailsUpdate: (itemsIds: number[]) => {
    dispatch(listsActions.updateItemsDetails(itemsIds));
  },
  onAddToCart: (
    claims: string,
    delivery: string,
    deliveryLocation: string,
    oneTimeAddress: null,
    partNumber: string,
    quantity: number,
    rushOrder: boolean,
    shipmentMarking: string,
    shipsfrom: string,
    ticketNumber: string,
    warrantyProvider: string
  ) =>
    dispatch(
      cartActions.addItemFromList(
        claims,
        delivery,
        deliveryLocation,
        oneTimeAddress,
        partNumber,
        quantity,
        rushOrder,
        shipmentMarking,
        shipsfrom,
        ticketNumber,
        warrantyProvider
      )
    ),
  onAddListToCart: (items: ICartServiceItem[]) =>
    dispatch(cartActions.addItemsFromList(items)),
  onGetTopProducts: () => dispatch(listsActions.getTopProductsList()),
  onGetCommonPurchases: () => dispatch(listsActions.getCommonPurchasesList()),
  onClearAlerts: () => {
    dispatch(listsActions.setError());
    dispatch(cartActions.setError());
    dispatch(cartActions.setSuccess());
  },
  onClearRemoveAlerts:()=>{
    dispatch(listsActions.clearRemoveAlert());
  }
});

export const pureComponent = Lists;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(withRouter(Lists as any)));

interface IDispatchFromProps {
  onLoad(callback: any): void;
  onClearList(): void;
  onClearfavList(): void;
  onGetList(id: number): any;
  onClearLists(id: number): any;
  onCreateList(name: string): any;
  onUpdateList(id: number, name: string): void;
  onDeleteList(id: number): void;
  onItemUpdate(
    itemId: number,
    name: string,
    mfc: string,
    quantity?: number,
    shipmentMarking?: string,
    warrantyProvider?: string,
    claims?: string
  ): void;
  onRemoveItem(itemId: number): void;
  onItemDetailsUpdate(itemId: number): void;
  onItemsDetailsUpdate(itemsIds: number[]): void;
  onAddToCart(
    claims: string,
    delivery: string,
    deliveryLocation: string,
    oneTimeAddress: string,
    partNumber: string,
    quantity: number,
    rushOrder: boolean,
    shipmentMarking: string,
    shipsfrom: string,
    ticketNumber: string,
    warrantyProvider: string
  ): void;
  onAddListToCart(items: ICartServiceItem[]): void;
  onGetTopProducts(): void;
  onGetCommonPurchases(): void;
  onClearAlerts(): void;
  onClearRemoveAlerts(): void;
}
